/**
 * @fileoverview gRPC-Web generated client stub for landscope.mapviewer.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v6.33.5
// source: landscope-map-viewer.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.landscope = {};
proto.landscope.mapviewer = {};
proto.landscope.mapviewer.v1 = require('./landscope-map-viewer_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.UserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateUserRequest,
 *   !proto.landscope.mapviewer.v1.CreateUserResponse>}
 */
const methodDescriptor_UserService_CreateUser = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/CreateUser',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateUserRequest,
  proto.landscope.mapviewer.v1.CreateUserResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateUserResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.createUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUser,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateUserResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.createUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.VerifyUserRequest,
 *   !proto.landscope.mapviewer.v1.VerifyUserResponse>}
 */
const methodDescriptor_UserService_Verify = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/Verify',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.VerifyUserRequest,
  proto.landscope.mapviewer.v1.VerifyUserResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.VerifyUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.VerifyUserResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.VerifyUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.VerifyUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.VerifyUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.verify =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/Verify',
      request,
      metadata || {},
      methodDescriptor_UserService_Verify,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.VerifyUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.VerifyUserResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.verify =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/Verify',
      request,
      metadata || {},
      methodDescriptor_UserService_Verify);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.LoginRequest,
 *   !proto.landscope.mapviewer.v1.LoginResponse>}
 */
const methodDescriptor_UserService_Login = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/Login',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.LoginRequest,
  proto.landscope.mapviewer.v1.LoginResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/Login',
      request,
      metadata || {},
      methodDescriptor_UserService_Login,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/Login',
      request,
      metadata || {},
      methodDescriptor_UserService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.StartExternalLoginRequest,
 *   !proto.landscope.mapviewer.v1.StartExternalLoginResponse>}
 */
const methodDescriptor_UserService_StartExternalLogin = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/StartExternalLogin',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.StartExternalLoginRequest,
  proto.landscope.mapviewer.v1.StartExternalLoginResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.StartExternalLoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.StartExternalLoginResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.StartExternalLoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.StartExternalLoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.StartExternalLoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.startExternalLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/StartExternalLogin',
      request,
      metadata || {},
      methodDescriptor_UserService_StartExternalLogin,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StartExternalLoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.StartExternalLoginResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.startExternalLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/StartExternalLogin',
      request,
      metadata || {},
      methodDescriptor_UserService_StartExternalLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CompleteExternalLoginRequest,
 *   !proto.landscope.mapviewer.v1.CompleteExternalLoginResponse>}
 */
const methodDescriptor_UserService_CompleteExternalLogin = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/CompleteExternalLogin',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CompleteExternalLoginRequest,
  proto.landscope.mapviewer.v1.CompleteExternalLoginResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CompleteExternalLoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.completeExternalLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/CompleteExternalLogin',
      request,
      metadata || {},
      methodDescriptor_UserService_CompleteExternalLogin,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.completeExternalLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/CompleteExternalLogin',
      request,
      metadata || {},
      methodDescriptor_UserService_CompleteExternalLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ResetPasswordRequest,
 *   !proto.landscope.mapviewer.v1.ResetPasswordResponse>}
 */
const methodDescriptor_UserService_ResetPassword = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/ResetPassword',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ResetPasswordRequest,
  proto.landscope.mapviewer.v1.ResetPasswordResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ResetPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ResetPasswordResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ResetPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ResetPasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ResetPasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.resetPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/ResetPassword',
      request,
      metadata || {},
      methodDescriptor_UserService_ResetPassword,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ResetPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ResetPasswordResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.resetPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/ResetPassword',
      request,
      metadata || {},
      methodDescriptor_UserService_ResetPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest,
 *   !proto.landscope.mapviewer.v1.RequestPasswordResetResponse>}
 */
const methodDescriptor_UserService_RequestPasswordReset = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/RequestPasswordReset',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest,
  proto.landscope.mapviewer.v1.RequestPasswordResetResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RequestPasswordResetResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RequestPasswordResetResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RequestPasswordResetResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.requestPasswordReset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/RequestPasswordReset',
      request,
      metadata || {},
      methodDescriptor_UserService_RequestPasswordReset,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RequestPasswordResetResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.requestPasswordReset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/RequestPasswordReset',
      request,
      metadata || {},
      methodDescriptor_UserService_RequestPasswordReset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateDemoAccessRequest,
 *   !proto.landscope.mapviewer.v1.CreateDemoAccessResponse>}
 */
const methodDescriptor_UserService_CreateDemoAccess = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/CreateDemoAccess',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateDemoAccessRequest,
  proto.landscope.mapviewer.v1.CreateDemoAccessResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateDemoAccessResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateDemoAccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateDemoAccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.createDemoAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/CreateDemoAccess',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateDemoAccess,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateDemoAccessResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.createDemoAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/CreateDemoAccess',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateDemoAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ResendVerificationEmailRequest,
 *   !proto.landscope.mapviewer.v1.ResendVerificationEmailResponse>}
 */
const methodDescriptor_UserService_ResendVerificationEmail = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserService/ResendVerificationEmail',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ResendVerificationEmailRequest,
  proto.landscope.mapviewer.v1.ResendVerificationEmailResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ResendVerificationEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserServiceClient.prototype.resendVerificationEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/ResendVerificationEmail',
      request,
      metadata || {},
      methodDescriptor_UserService_ResendVerificationEmail,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserServicePromiseClient.prototype.resendVerificationEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserService/ResendVerificationEmail',
      request,
      metadata || {},
      methodDescriptor_UserService_ResendVerificationEmail);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.AreaServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.AreaServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CalculateAreaRequest,
 *   !proto.landscope.mapviewer.v1.CalculateAreaResponse>}
 */
const methodDescriptor_AreaService_CalculateArea = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.AreaService/CalculateArea',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CalculateAreaRequest,
  proto.landscope.mapviewer.v1.CalculateAreaResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CalculateAreaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CalculateAreaResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CalculateAreaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CalculateAreaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CalculateAreaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.AreaServiceClient.prototype.calculateArea =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.AreaService/CalculateArea',
      request,
      metadata || {},
      methodDescriptor_AreaService_CalculateArea,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CalculateAreaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CalculateAreaResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.AreaServicePromiseClient.prototype.calculateArea =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.AreaService/CalculateArea',
      request,
      metadata || {},
      methodDescriptor_AreaService_CalculateArea);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.AddressSearchServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.AddressSearchServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.SearchAddressRequest,
 *   !proto.landscope.mapviewer.v1.SearchAddressResponse>}
 */
const methodDescriptor_AddressSearchService_SearchAddress = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.AddressSearchService/SearchAddress',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.SearchAddressRequest,
  proto.landscope.mapviewer.v1.SearchAddressResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.SearchAddressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.SearchAddressResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.SearchAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.SearchAddressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.SearchAddressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.AddressSearchServiceClient.prototype.searchAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.AddressSearchService/SearchAddress',
      request,
      metadata || {},
      methodDescriptor_AddressSearchService_SearchAddress,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.SearchAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.SearchAddressResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.AddressSearchServicePromiseClient.prototype.searchAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.AddressSearchService/SearchAddress',
      request,
      metadata || {},
      methodDescriptor_AddressSearchService_SearchAddress);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetCurrentUserRequest,
 *   !proto.landscope.mapviewer.v1.GetCurrentUserResponse>}
 */
const methodDescriptor_LoggedInUserService_GetCurrentUser = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/GetCurrentUser',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetCurrentUserRequest,
  proto.landscope.mapviewer.v1.GetCurrentUserResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetCurrentUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetCurrentUserResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetCurrentUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetCurrentUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetCurrentUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.getCurrentUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/GetCurrentUser',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_GetCurrentUser,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetCurrentUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetCurrentUserResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.getCurrentUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/GetCurrentUser',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_GetCurrentUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.LogoutRequest,
 *   !proto.landscope.mapviewer.v1.LogoutResponse>}
 */
const methodDescriptor_LoggedInUserService_Logout = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/Logout',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.LogoutRequest,
  proto.landscope.mapviewer.v1.LogoutResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.LogoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.LogoutResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.LogoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.LogoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.LogoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.logout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/Logout',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_Logout,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.LogoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.LogoutResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.logout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/Logout',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_Logout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.landscope.mapviewer.v1.RequestPasswordResetResponse>}
 */
const methodDescriptor_LoggedInUserService_RequestPasswordReset = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/RequestPasswordReset',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.landscope.mapviewer.v1.RequestPasswordResetResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RequestPasswordResetResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RequestPasswordResetResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RequestPasswordResetResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.requestPasswordReset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/RequestPasswordReset',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_RequestPasswordReset,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RequestPasswordResetResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.requestPasswordReset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/RequestPasswordReset',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_RequestPasswordReset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateProfileRequest,
 *   !proto.landscope.mapviewer.v1.UpdateProfileResponse>}
 */
const methodDescriptor_LoggedInUserService_UpdateProfile = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/UpdateProfile',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateProfileRequest,
  proto.landscope.mapviewer.v1.UpdateProfileResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateProfileResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.updateProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/UpdateProfile',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_UpdateProfile,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateProfileResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.updateProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/UpdateProfile',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_UpdateProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.SetUsagePurposeRequest,
 *   !proto.landscope.mapviewer.v1.SetUsagePurposeResponse>}
 */
const methodDescriptor_LoggedInUserService_SetUsagePurpose = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/SetUsagePurpose',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.SetUsagePurposeRequest,
  proto.landscope.mapviewer.v1.SetUsagePurposeResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.SetUsagePurposeResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.SetUsagePurposeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.SetUsagePurposeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.setUsagePurpose =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/SetUsagePurpose',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_SetUsagePurpose,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.SetUsagePurposeResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.setUsagePurpose =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/SetUsagePurpose',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_SetUsagePurpose);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest,
 *   !proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse>}
 */
const methodDescriptor_LoggedInUserService_ListUsagePurposeOptions = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/ListUsagePurposeOptions',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest,
  proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.listUsagePurposeOptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/ListUsagePurposeOptions',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_ListUsagePurposeOptions,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.listUsagePurposeOptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/ListUsagePurposeOptions',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_ListUsagePurposeOptions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UploadAvatarRequest,
 *   !proto.landscope.mapviewer.v1.UploadAvatarResponse>}
 */
const methodDescriptor_LoggedInUserService_UploadAvatar = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/UploadAvatar',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UploadAvatarRequest,
  proto.landscope.mapviewer.v1.UploadAvatarResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UploadAvatarRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UploadAvatarResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UploadAvatarRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UploadAvatarResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UploadAvatarResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.uploadAvatar =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/UploadAvatar',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_UploadAvatar,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UploadAvatarRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UploadAvatarResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.uploadAvatar =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/UploadAvatar',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_UploadAvatar);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RemoveAvatarRequest,
 *   !proto.landscope.mapviewer.v1.RemoveAvatarResponse>}
 */
const methodDescriptor_LoggedInUserService_RemoveAvatar = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/RemoveAvatar',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RemoveAvatarRequest,
  proto.landscope.mapviewer.v1.RemoveAvatarResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RemoveAvatarRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RemoveAvatarResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RemoveAvatarRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RemoveAvatarResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RemoveAvatarResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.removeAvatar =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/RemoveAvatar',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_RemoveAvatar,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RemoveAvatarRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RemoveAvatarResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.removeAvatar =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/RemoveAvatar',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_RemoveAvatar);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.SubmitSupportMessageRequest,
 *   !proto.landscope.mapviewer.v1.SubmitSupportMessageResponse>}
 */
const methodDescriptor_LoggedInUserService_SubmitSupportMessage = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/SubmitSupportMessage',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.SubmitSupportMessageRequest,
  proto.landscope.mapviewer.v1.SubmitSupportMessageResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.SubmitSupportMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.SubmitSupportMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.submitSupportMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/SubmitSupportMessage',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_SubmitSupportMessage,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.SubmitSupportMessageResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.submitSupportMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/SubmitSupportMessage',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_SubmitSupportMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest,
 *   !proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse>}
 */
const methodDescriptor_LoggedInUserService_GetMyCommunicationPreferences = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/GetMyCommunicationPreferences',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest,
  proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.getMyCommunicationPreferences =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/GetMyCommunicationPreferences',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_GetMyCommunicationPreferences,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.getMyCommunicationPreferences =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/GetMyCommunicationPreferences',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_GetMyCommunicationPreferences);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest,
 *   !proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse>}
 */
const methodDescriptor_LoggedInUserService_UpdateMyCommunicationPreferences = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/UpdateMyCommunicationPreferences',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest,
  proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.updateMyCommunicationPreferences =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/UpdateMyCommunicationPreferences',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_UpdateMyCommunicationPreferences,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.updateMyCommunicationPreferences =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/UpdateMyCommunicationPreferences',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_UpdateMyCommunicationPreferences);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RequestAccountDeletionRequest,
 *   !proto.landscope.mapviewer.v1.RequestAccountDeletionResponse>}
 */
const methodDescriptor_LoggedInUserService_RequestAccountDeletion = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LoggedInUserService/RequestAccountDeletion',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RequestAccountDeletionRequest,
  proto.landscope.mapviewer.v1.RequestAccountDeletionResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RequestAccountDeletionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LoggedInUserServiceClient.prototype.requestAccountDeletion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/RequestAccountDeletion',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_RequestAccountDeletion,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LoggedInUserServicePromiseClient.prototype.requestAccountDeletion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LoggedInUserService/RequestAccountDeletion',
      request,
      metadata || {},
      methodDescriptor_LoggedInUserService_RequestAccountDeletion);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.WorkspaceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.WorkspaceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.landscope.mapviewer.v1.ListMyWorkspacesResponse>}
 */
const methodDescriptor_WorkspaceService_ListMyWorkspaces = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.WorkspaceService/ListMyWorkspaces',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.landscope.mapviewer.v1.ListMyWorkspacesResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ListMyWorkspacesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.WorkspaceServiceClient.prototype.listMyWorkspaces =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/ListMyWorkspaces',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_ListMyWorkspaces,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.WorkspaceServicePromiseClient.prototype.listMyWorkspaces =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/ListMyWorkspaces',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_ListMyWorkspaces);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest,
 *   !proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse>}
 */
const methodDescriptor_WorkspaceService_SetActiveWorkspace = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.WorkspaceService/SetActiveWorkspace',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest,
  proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.WorkspaceServiceClient.prototype.setActiveWorkspace =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/SetActiveWorkspace',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_SetActiveWorkspace,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.WorkspaceServicePromiseClient.prototype.setActiveWorkspace =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/SetActiveWorkspace',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_SetActiveWorkspace);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest,
 *   !proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse>}
 */
const methodDescriptor_WorkspaceService_InviteWorkspaceMember = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.WorkspaceService/InviteWorkspaceMember',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest,
  proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.WorkspaceServiceClient.prototype.inviteWorkspaceMember =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/InviteWorkspaceMember',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_InviteWorkspaceMember,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.WorkspaceServicePromiseClient.prototype.inviteWorkspaceMember =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/InviteWorkspaceMember',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_InviteWorkspaceMember);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest,
 *   !proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse>}
 */
const methodDescriptor_WorkspaceService_ListWorkspaceMembers = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.WorkspaceService/ListWorkspaceMembers',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest,
  proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.WorkspaceServiceClient.prototype.listWorkspaceMembers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/ListWorkspaceMembers',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_ListWorkspaceMembers,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.WorkspaceServicePromiseClient.prototype.listWorkspaceMembers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/ListWorkspaceMembers',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_ListWorkspaceMembers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateWorkspaceRequest,
 *   !proto.landscope.mapviewer.v1.CreateWorkspaceResponse>}
 */
const methodDescriptor_WorkspaceService_CreateWorkspace = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.WorkspaceService/CreateWorkspace',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateWorkspaceRequest,
  proto.landscope.mapviewer.v1.CreateWorkspaceResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateWorkspaceResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateWorkspaceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateWorkspaceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.WorkspaceServiceClient.prototype.createWorkspace =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/CreateWorkspace',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_CreateWorkspace,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateWorkspaceResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.WorkspaceServicePromiseClient.prototype.createWorkspace =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/CreateWorkspace',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_CreateWorkspace);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RenameWorkspaceRequest,
 *   !proto.landscope.mapviewer.v1.RenameWorkspaceResponse>}
 */
const methodDescriptor_WorkspaceService_RenameWorkspace = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.WorkspaceService/RenameWorkspace',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RenameWorkspaceRequest,
  proto.landscope.mapviewer.v1.RenameWorkspaceResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RenameWorkspaceResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RenameWorkspaceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RenameWorkspaceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.WorkspaceServiceClient.prototype.renameWorkspace =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/RenameWorkspace',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_RenameWorkspace,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RenameWorkspaceResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.WorkspaceServicePromiseClient.prototype.renameWorkspace =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/RenameWorkspace',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_RenameWorkspace);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest,
 *   !proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse>}
 */
const methodDescriptor_WorkspaceService_RemoveWorkspaceMember = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.WorkspaceService/RemoveWorkspaceMember',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest,
  proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.WorkspaceServiceClient.prototype.removeWorkspaceMember =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/RemoveWorkspaceMember',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_RemoveWorkspaceMember,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.WorkspaceServicePromiseClient.prototype.removeWorkspaceMember =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.WorkspaceService/RemoveWorkspaceMember',
      request,
      metadata || {},
      methodDescriptor_WorkspaceService_RemoveWorkspaceMember);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest,
 *   !proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse>}
 */
const methodDescriptor_UserProjectsService_NewProjectFromPolygon = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/NewProjectFromPolygon',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest,
  proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.newProjectFromPolygon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/NewProjectFromPolygon',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_NewProjectFromPolygon,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.newProjectFromPolygon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/NewProjectFromPolygon',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_NewProjectFromPolygon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.landscope.mapviewer.v1.GetUserProjectsResponse>}
 */
const methodDescriptor_UserProjectsService_GetUserProjects = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetUserProjects',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.landscope.mapviewer.v1.GetUserProjectsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetUserProjectsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetUserProjectsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetUserProjectsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getUserProjects =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetUserProjects',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetUserProjects,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetUserProjectsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getUserProjects =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetUserProjects',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetUserProjects);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetProjectStructureRequest,
 *   !proto.landscope.mapviewer.v1.GetProjectStructureResponse>}
 */
const methodDescriptor_UserProjectsService_GetProjectStructure = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetProjectStructure',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetProjectStructureRequest,
  proto.landscope.mapviewer.v1.GetProjectStructureResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetProjectStructureResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetProjectStructureResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetProjectStructureResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getProjectStructure =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetProjectStructure',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetProjectStructure,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetProjectStructureResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getProjectStructure =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetProjectStructure',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetProjectStructure);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetArtifactRequest,
 *   !proto.landscope.mapviewer.v1.GetArtifactResponse>}
 */
const methodDescriptor_UserProjectsService_GetArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetArtifactRequest,
  proto.landscope.mapviewer.v1.GetArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RecordLayerOpenedRequest,
 *   !proto.landscope.mapviewer.v1.RecordLayerOpenedResponse>}
 */
const methodDescriptor_UserProjectsService_RecordLayerOpened = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/RecordLayerOpened',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RecordLayerOpenedRequest,
  proto.landscope.mapviewer.v1.RecordLayerOpenedResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RecordLayerOpenedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RecordLayerOpenedResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.recordLayerOpened =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RecordLayerOpened',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RecordLayerOpened,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RecordLayerOpenedResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.recordLayerOpened =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RecordLayerOpened',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RecordLayerOpened);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetProjectStatisticsRequest,
 *   !proto.landscope.mapviewer.v1.GetProjectStatisticsResponse>}
 */
const methodDescriptor_UserProjectsService_GetProjectStatistics = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetProjectStatistics',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetProjectStatisticsRequest,
  proto.landscope.mapviewer.v1.GetProjectStatisticsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetProjectStatisticsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getProjectStatistics =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetProjectStatistics',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetProjectStatistics,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getProjectStatistics =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetProjectStatistics',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetProjectStatistics);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest,
 *   !proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse>}
 */
const methodDescriptor_UserProjectsService_NewProjectFromDEMInit = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/NewProjectFromDEMInit',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest,
  proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.newProjectFromDEMInit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/NewProjectFromDEMInit',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_NewProjectFromDEMInit,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.newProjectFromDEMInit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/NewProjectFromDEMInit',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_NewProjectFromDEMInit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest,
 *   !proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse>}
 */
const methodDescriptor_UserProjectsService_FinalizeDEMUpload = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/FinalizeDEMUpload',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest,
  proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.finalizeDEMUpload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/FinalizeDEMUpload',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_FinalizeDEMUpload,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.finalizeDEMUpload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/FinalizeDEMUpload',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_FinalizeDEMUpload);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.StartDemoProcessingRequest,
 *   !proto.landscope.mapviewer.v1.StartDemoProcessingResponse>}
 */
const methodDescriptor_UserProjectsService_StartDemoProcessing = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/StartDemoProcessing',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.StartDemoProcessingRequest,
  proto.landscope.mapviewer.v1.StartDemoProcessingResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.StartDemoProcessingResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.StartDemoProcessingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.StartDemoProcessingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.startDemoProcessing =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/StartDemoProcessing',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_StartDemoProcessing,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.StartDemoProcessingResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.startDemoProcessing =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/StartDemoProcessing',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_StartDemoProcessing);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest,
 *   !proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse>}
 */
const methodDescriptor_UserProjectsService_RequestFullResolutionBuild = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/RequestFullResolutionBuild',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest,
  proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.requestFullResolutionBuild =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RequestFullResolutionBuild',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RequestFullResolutionBuild,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.requestFullResolutionBuild =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RequestFullResolutionBuild',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RequestFullResolutionBuild);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse>}
 */
const methodDescriptor_UserProjectsService_GetDemoSlotInfo = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetDemoSlotInfo',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getDemoSlotInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetDemoSlotInfo',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetDemoSlotInfo,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getDemoSlotInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetDemoSlotInfo',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetDemoSlotInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RetryLayerProcessingRequest,
 *   !proto.landscope.mapviewer.v1.RetryLayerProcessingResponse>}
 */
const methodDescriptor_UserProjectsService_RetryLayerProcessing = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/RetryLayerProcessing',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RetryLayerProcessingRequest,
  proto.landscope.mapviewer.v1.RetryLayerProcessingResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RetryLayerProcessingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.retryLayerProcessing =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RetryLayerProcessing',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RetryLayerProcessing,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.retryLayerProcessing =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RetryLayerProcessing',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RetryLayerProcessing);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateProjectDownloadRequest,
 *   !proto.landscope.mapviewer.v1.CreateProjectDownloadResponse>}
 */
const methodDescriptor_UserProjectsService_CreateProjectDownload = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/CreateProjectDownload',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateProjectDownloadRequest,
  proto.landscope.mapviewer.v1.CreateProjectDownloadResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateProjectDownloadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.createProjectDownload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateProjectDownload',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateProjectDownload,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.createProjectDownload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateProjectDownload',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateProjectDownload);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest,
 *   !proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse>}
 */
const methodDescriptor_UserProjectsService_GetProjectDownloadStatus = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetProjectDownloadStatus',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest,
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getProjectDownloadStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetProjectDownloadStatus',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetProjectDownloadStatus,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getProjectDownloadStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetProjectDownloadStatus',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetProjectDownloadStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ExportArtifactRequest,
 *   !proto.landscope.mapviewer.v1.ExportArtifactResponse>}
 */
const methodDescriptor_UserProjectsService_ExportArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ExportArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ExportArtifactRequest,
  proto.landscope.mapviewer.v1.ExportArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ExportArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ExportArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ExportArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.exportArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ExportArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ExportArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ExportArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.exportArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ExportArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ExportArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest,
 *   !proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse>}
 */
const methodDescriptor_UserProjectsService_GetSupportedExportFormats = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetSupportedExportFormats',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest,
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getSupportedExportFormats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetSupportedExportFormats',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetSupportedExportFormats,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getSupportedExportFormats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetSupportedExportFormats',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetSupportedExportFormats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ExportUserArtifactRequest,
 *   !proto.landscope.mapviewer.v1.ExportUserArtifactResponse>}
 */
const methodDescriptor_UserProjectsService_ExportUserArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ExportUserArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ExportUserArtifactRequest,
  proto.landscope.mapviewer.v1.ExportUserArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ExportUserArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ExportUserArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ExportUserArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.exportUserArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ExportUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ExportUserArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ExportUserArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.exportUserArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ExportUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ExportUserArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ExportUserFolderRequest,
 *   !proto.landscope.mapviewer.v1.ExportUserFolderResponse>}
 */
const methodDescriptor_UserProjectsService_ExportUserFolder = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ExportUserFolder',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ExportUserFolderRequest,
  proto.landscope.mapviewer.v1.ExportUserFolderResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ExportUserFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ExportUserFolderResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ExportUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ExportUserFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ExportUserFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.exportUserFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ExportUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ExportUserFolder,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExportUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ExportUserFolderResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.exportUserFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ExportUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ExportUserFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateProjectRequest,
 *   !proto.landscope.mapviewer.v1.UpdateProjectResponse>}
 */
const methodDescriptor_UserProjectsService_UpdateProject = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/UpdateProject',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateProjectRequest,
  proto.landscope.mapviewer.v1.UpdateProjectResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateProjectResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.updateProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateProject',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateProject,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateProjectResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.updateProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateProject',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RemoveProjectRequest,
 *   !proto.landscope.mapviewer.v1.RemoveProjectResponse>}
 */
const methodDescriptor_UserProjectsService_RemoveProject = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/RemoveProject',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RemoveProjectRequest,
  proto.landscope.mapviewer.v1.RemoveProjectResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RemoveProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RemoveProjectResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RemoveProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RemoveProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RemoveProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.removeProject =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RemoveProject',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RemoveProject,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RemoveProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RemoveProjectResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.removeProject =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RemoveProject',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RemoveProject);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest,
 *   !proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse>}
 */
const methodDescriptor_UserProjectsService_UpdateProjectDataSourceMetadata = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/UpdateProjectDataSourceMetadata',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest,
  proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.updateProjectDataSourceMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateProjectDataSourceMetadata',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateProjectDataSourceMetadata,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.updateProjectDataSourceMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateProjectDataSourceMetadata',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateProjectDataSourceMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.InviteCollaboratorRequest,
 *   !proto.landscope.mapviewer.v1.InviteCollaboratorResponse>}
 */
const methodDescriptor_UserProjectsService_InviteCollaborator = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/InviteCollaborator',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.InviteCollaboratorRequest,
  proto.landscope.mapviewer.v1.InviteCollaboratorResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.InviteCollaboratorResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.InviteCollaboratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.InviteCollaboratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.inviteCollaborator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/InviteCollaborator',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_InviteCollaborator,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.InviteCollaboratorResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.inviteCollaborator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/InviteCollaborator',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_InviteCollaborator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.RemoveCollaboratorRequest,
 *   !proto.landscope.mapviewer.v1.RemoveCollaboratorResponse>}
 */
const methodDescriptor_UserProjectsService_RemoveCollaborator = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/RemoveCollaborator',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.RemoveCollaboratorRequest,
  proto.landscope.mapviewer.v1.RemoveCollaboratorResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.RemoveCollaboratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.removeCollaborator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RemoveCollaborator',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RemoveCollaborator,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.removeCollaborator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/RemoveCollaborator',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_RemoveCollaborator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ListCollaboratorsRequest,
 *   !proto.landscope.mapviewer.v1.ListCollaboratorsResponse>}
 */
const methodDescriptor_UserProjectsService_ListCollaborators = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ListCollaborators',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ListCollaboratorsRequest,
  proto.landscope.mapviewer.v1.ListCollaboratorsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ListCollaboratorsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ListCollaboratorsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ListCollaboratorsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.listCollaborators =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ListCollaborators',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ListCollaborators,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ListCollaboratorsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.listCollaborators =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ListCollaborators',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ListCollaborators);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest,
 *   !proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse>}
 */
const methodDescriptor_UserProjectsService_SetSharedProjectHome = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/SetSharedProjectHome',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest,
  proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.setSharedProjectHome =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/SetSharedProjectHome',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_SetSharedProjectHome,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.setSharedProjectHome =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/SetSharedProjectHome',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_SetSharedProjectHome);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateScopeRequest,
 *   !proto.landscope.mapviewer.v1.CreateScopeResponse>}
 */
const methodDescriptor_UserProjectsService_CreateScope = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/CreateScope',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateScopeRequest,
  proto.landscope.mapviewer.v1.CreateScopeResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateScopeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateScopeResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateScopeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateScopeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.createScope =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateScope',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateScope,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateScopeResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.createScope =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateScope',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateScope);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetScopesRequest,
 *   !proto.landscope.mapviewer.v1.GetScopesResponse>}
 */
const methodDescriptor_UserProjectsService_GetScopes = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetScopes',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetScopesRequest,
  proto.landscope.mapviewer.v1.GetScopesResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetScopesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetScopesResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetScopesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetScopesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetScopesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getScopes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetScopes',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetScopes,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetScopesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetScopesResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getScopes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetScopes',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetScopes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetScopeRequest,
 *   !proto.landscope.mapviewer.v1.GetScopeResponse>}
 */
const methodDescriptor_UserProjectsService_GetScope = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetScope',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetScopeRequest,
  proto.landscope.mapviewer.v1.GetScopeResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetScopeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetScopeResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetScopeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetScopeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getScope =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetScope',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetScope,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetScopeResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getScope =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetScope',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetScope);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateScopeRequest,
 *   !proto.landscope.mapviewer.v1.UpdateScopeResponse>}
 */
const methodDescriptor_UserProjectsService_UpdateScope = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/UpdateScope',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateScopeRequest,
  proto.landscope.mapviewer.v1.UpdateScopeResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateScopeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateScopeResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateScopeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateScopeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.updateScope =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateScope',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateScope,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateScopeResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.updateScope =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateScope',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateScope);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.DeleteScopeRequest,
 *   !proto.landscope.mapviewer.v1.DeleteScopeResponse>}
 */
const methodDescriptor_UserProjectsService_DeleteScope = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/DeleteScope',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.DeleteScopeRequest,
  proto.landscope.mapviewer.v1.DeleteScopeResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.DeleteScopeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.DeleteScopeResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.DeleteScopeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.DeleteScopeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.deleteScope =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteScope',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteScope,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.DeleteScopeResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.deleteScope =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteScope',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteScope);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ReorderScopesRequest,
 *   !proto.landscope.mapviewer.v1.ReorderScopesResponse>}
 */
const methodDescriptor_UserProjectsService_ReorderScopes = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ReorderScopes',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ReorderScopesRequest,
  proto.landscope.mapviewer.v1.ReorderScopesResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ReorderScopesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ReorderScopesResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ReorderScopesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ReorderScopesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ReorderScopesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.reorderScopes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ReorderScopes',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ReorderScopes,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ReorderScopesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ReorderScopesResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.reorderScopes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ReorderScopes',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ReorderScopes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest,
 *   !proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse>}
 */
const methodDescriptor_UserProjectsService_CalculatePolygonStatistics = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/CalculatePolygonStatistics',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest,
  proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.calculatePolygonStatistics =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CalculatePolygonStatistics',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CalculatePolygonStatistics,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.calculatePolygonStatistics =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CalculatePolygonStatistics',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CalculatePolygonStatistics);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest,
 *   !proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse>}
 */
const methodDescriptor_UserProjectsService_CalculatePolygonSurfaceArea = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/CalculatePolygonSurfaceArea',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest,
  proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.calculatePolygonSurfaceArea =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CalculatePolygonSurfaceArea',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CalculatePolygonSurfaceArea,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.calculatePolygonSurfaceArea =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CalculatePolygonSurfaceArea',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CalculatePolygonSurfaceArea);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateCommentRequest,
 *   !proto.landscope.mapviewer.v1.CreateCommentResponse>}
 */
const methodDescriptor_UserProjectsService_CreateComment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/CreateComment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateCommentRequest,
  proto.landscope.mapviewer.v1.CreateCommentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateCommentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.createComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateComment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateCommentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.createComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ReplyToCommentRequest,
 *   !proto.landscope.mapviewer.v1.CreateCommentResponse>}
 */
const methodDescriptor_UserProjectsService_ReplyToComment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ReplyToComment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ReplyToCommentRequest,
  proto.landscope.mapviewer.v1.CreateCommentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateCommentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.replyToComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ReplyToComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ReplyToComment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateCommentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.replyToComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ReplyToComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ReplyToComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateCommentRequest,
 *   !proto.landscope.mapviewer.v1.UpdateCommentResponse>}
 */
const methodDescriptor_UserProjectsService_UpdateComment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/UpdateComment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateCommentRequest,
  proto.landscope.mapviewer.v1.UpdateCommentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateCommentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.updateComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateComment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateCommentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.updateComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.DeleteCommentRequest,
 *   !proto.landscope.mapviewer.v1.DeleteCommentResponse>}
 */
const methodDescriptor_UserProjectsService_DeleteComment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/DeleteComment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.DeleteCommentRequest,
  proto.landscope.mapviewer.v1.DeleteCommentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.DeleteCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.DeleteCommentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.DeleteCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.DeleteCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.deleteComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteComment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.DeleteCommentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.deleteComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetCommentsRequest,
 *   !proto.landscope.mapviewer.v1.GetCommentsResponse>}
 */
const methodDescriptor_UserProjectsService_GetComments = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetComments',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetCommentsRequest,
  proto.landscope.mapviewer.v1.GetCommentsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetCommentsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetComments',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetComments,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetComments',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetCommentRequest,
 *   !proto.landscope.mapviewer.v1.GetCommentResponse>}
 */
const methodDescriptor_UserProjectsService_GetComment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetComment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetCommentRequest,
  proto.landscope.mapviewer.v1.GetCommentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetCommentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetComment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetCommentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetComment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest,
 *   !proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse>}
 */
const methodDescriptor_UserProjectsService_ListProjectCommentTags = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ListProjectCommentTags',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest,
  proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.listProjectCommentTags =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ListProjectCommentTags',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ListProjectCommentTags,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.listProjectCommentTags =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ListProjectCommentTags',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ListProjectCommentTags);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest,
 *   !proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse>}
 */
const methodDescriptor_UserProjectsService_GetAttachmentUploadURL = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetAttachmentUploadURL',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest,
  proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getAttachmentUploadURL =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetAttachmentUploadURL',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetAttachmentUploadURL,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getAttachmentUploadURL =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetAttachmentUploadURL',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetAttachmentUploadURL);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ConfirmAttachmentRequest,
 *   !proto.landscope.mapviewer.v1.ConfirmAttachmentResponse>}
 */
const methodDescriptor_UserProjectsService_ConfirmAttachment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ConfirmAttachment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ConfirmAttachmentRequest,
  proto.landscope.mapviewer.v1.ConfirmAttachmentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ConfirmAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.confirmAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ConfirmAttachment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ConfirmAttachment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.confirmAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ConfirmAttachment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ConfirmAttachment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.DeleteAttachmentRequest,
 *   !proto.landscope.mapviewer.v1.DeleteAttachmentResponse>}
 */
const methodDescriptor_UserProjectsService_DeleteAttachment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/DeleteAttachment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.DeleteAttachmentRequest,
  proto.landscope.mapviewer.v1.DeleteAttachmentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.DeleteAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.DeleteAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.DeleteAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.deleteAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteAttachment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteAttachment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.DeleteAttachmentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.deleteAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteAttachment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteAttachment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateArtifactNoteRequest,
 *   !proto.landscope.mapviewer.v1.CreateArtifactNoteResponse>}
 */
const methodDescriptor_UserProjectsService_CreateArtifactNote = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/CreateArtifactNote',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateArtifactNoteRequest,
  proto.landscope.mapviewer.v1.CreateArtifactNoteResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateArtifactNoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.createArtifactNote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateArtifactNote',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateArtifactNote,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.createArtifactNote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateArtifactNote',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateArtifactNote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ListArtifactNotesRequest,
 *   !proto.landscope.mapviewer.v1.ListArtifactNotesResponse>}
 */
const methodDescriptor_UserProjectsService_ListArtifactNotes = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ListArtifactNotes',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ListArtifactNotesRequest,
  proto.landscope.mapviewer.v1.ListArtifactNotesResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ListArtifactNotesResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ListArtifactNotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ListArtifactNotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.listArtifactNotes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ListArtifactNotes',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ListArtifactNotes,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ListArtifactNotesResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.listArtifactNotes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ListArtifactNotes',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ListArtifactNotes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest,
 *   !proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse>}
 */
const methodDescriptor_UserProjectsService_UpdateArtifactNote = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/UpdateArtifactNote',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest,
  proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.updateArtifactNote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateArtifactNote',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateArtifactNote,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.updateArtifactNote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateArtifactNote',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateArtifactNote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest,
 *   !proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse>}
 */
const methodDescriptor_UserProjectsService_DeleteArtifactNote = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/DeleteArtifactNote',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest,
  proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.deleteArtifactNote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteArtifactNote',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteArtifactNote,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.deleteArtifactNote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteArtifactNote',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteArtifactNote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest,
 *   !proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse>}
 */
const methodDescriptor_UserProjectsService_GetNoteAttachmentUploadURL = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetNoteAttachmentUploadURL',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest,
  proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getNoteAttachmentUploadURL =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetNoteAttachmentUploadURL',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetNoteAttachmentUploadURL,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getNoteAttachmentUploadURL =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetNoteAttachmentUploadURL',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetNoteAttachmentUploadURL);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest,
 *   !proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse>}
 */
const methodDescriptor_UserProjectsService_ConfirmNoteAttachment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ConfirmNoteAttachment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest,
  proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.confirmNoteAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ConfirmNoteAttachment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ConfirmNoteAttachment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.confirmNoteAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ConfirmNoteAttachment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ConfirmNoteAttachment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest,
 *   !proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse>}
 */
const methodDescriptor_UserProjectsService_DeleteNoteAttachment = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/DeleteNoteAttachment',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest,
  proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.deleteNoteAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteNoteAttachment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteNoteAttachment,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.deleteNoteAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteNoteAttachment',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteNoteAttachment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest,
 *   !proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse>}
 */
const methodDescriptor_UserProjectsService_ConvertUTMToLatLong = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ConvertUTMToLatLong',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest,
  proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.convertUTMToLatLong =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ConvertUTMToLatLong',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ConvertUTMToLatLong,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.convertUTMToLatLong =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ConvertUTMToLatLong',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ConvertUTMToLatLong);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest,
 *   !proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse>}
 */
const methodDescriptor_UserProjectsService_ConvertLatLongToUTM = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ConvertLatLongToUTM',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest,
  proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.convertLatLongToUTM =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ConvertLatLongToUTM',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ConvertLatLongToUTM,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.convertLatLongToUTM =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ConvertLatLongToUTM',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ConvertLatLongToUTM);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateUserFolderRequest,
 *   !proto.landscope.mapviewer.v1.CreateUserFolderResponse>}
 */
const methodDescriptor_UserProjectsService_CreateUserFolder = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/CreateUserFolder',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateUserFolderRequest,
  proto.landscope.mapviewer.v1.CreateUserFolderResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateUserFolderResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateUserFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateUserFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.createUserFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateUserFolder,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateUserFolderResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.createUserFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateUserFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetUserFoldersRequest,
 *   !proto.landscope.mapviewer.v1.GetUserFoldersResponse>}
 */
const methodDescriptor_UserProjectsService_GetUserFolders = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetUserFolders',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetUserFoldersRequest,
  proto.landscope.mapviewer.v1.GetUserFoldersResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetUserFoldersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetUserFoldersResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetUserFoldersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetUserFoldersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetUserFoldersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getUserFolders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetUserFolders',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetUserFolders,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetUserFoldersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetUserFoldersResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getUserFolders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetUserFolders',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetUserFolders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetUserFolderRequest,
 *   !proto.landscope.mapviewer.v1.GetUserFolderResponse>}
 */
const methodDescriptor_UserProjectsService_GetUserFolder = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetUserFolder',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetUserFolderRequest,
  proto.landscope.mapviewer.v1.GetUserFolderResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetUserFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetUserFolderResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetUserFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetUserFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getUserFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetUserFolder,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetUserFolderResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getUserFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetUserFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateUserFolderRequest,
 *   !proto.landscope.mapviewer.v1.UpdateUserFolderResponse>}
 */
const methodDescriptor_UserProjectsService_UpdateUserFolder = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/UpdateUserFolder',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateUserFolderRequest,
  proto.landscope.mapviewer.v1.UpdateUserFolderResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateUserFolderResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateUserFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateUserFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.updateUserFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateUserFolder,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateUserFolderResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.updateUserFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateUserFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.DeleteUserFolderRequest,
 *   !proto.landscope.mapviewer.v1.DeleteUserFolderResponse>}
 */
const methodDescriptor_UserProjectsService_DeleteUserFolder = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/DeleteUserFolder',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.DeleteUserFolderRequest,
  proto.landscope.mapviewer.v1.DeleteUserFolderResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.DeleteUserFolderResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.DeleteUserFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.DeleteUserFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.deleteUserFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteUserFolder,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.DeleteUserFolderResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.deleteUserFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteUserFolder',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteUserFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ReorderUserFoldersRequest,
 *   !proto.landscope.mapviewer.v1.ReorderUserFoldersResponse>}
 */
const methodDescriptor_UserProjectsService_ReorderUserFolders = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ReorderUserFolders',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ReorderUserFoldersRequest,
  proto.landscope.mapviewer.v1.ReorderUserFoldersResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ReorderUserFoldersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ReorderUserFoldersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.reorderUserFolders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ReorderUserFolders',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ReorderUserFolders,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ReorderUserFoldersResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.reorderUserFolders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ReorderUserFolders',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ReorderUserFolders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateUserArtifactRequest,
 *   !proto.landscope.mapviewer.v1.CreateUserArtifactResponse>}
 */
const methodDescriptor_UserProjectsService_CreateUserArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/CreateUserArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateUserArtifactRequest,
  proto.landscope.mapviewer.v1.CreateUserArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateUserArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateUserArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateUserArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.createUserArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateUserArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateUserArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.createUserArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/CreateUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_CreateUserArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetUserArtifactRequest,
 *   !proto.landscope.mapviewer.v1.GetUserArtifactResponse>}
 */
const methodDescriptor_UserProjectsService_GetUserArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/GetUserArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetUserArtifactRequest,
  proto.landscope.mapviewer.v1.GetUserArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetUserArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetUserArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetUserArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetUserArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.getUserArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetUserArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetUserArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.getUserArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/GetUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_GetUserArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.UpdateUserArtifactRequest,
 *   !proto.landscope.mapviewer.v1.UpdateUserArtifactResponse>}
 */
const methodDescriptor_UserProjectsService_UpdateUserArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/UpdateUserArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.UpdateUserArtifactRequest,
  proto.landscope.mapviewer.v1.UpdateUserArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.UpdateUserArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.UpdateUserArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.updateUserArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateUserArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.UpdateUserArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.updateUserArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/UpdateUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_UpdateUserArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.DeleteUserArtifactRequest,
 *   !proto.landscope.mapviewer.v1.DeleteUserArtifactResponse>}
 */
const methodDescriptor_UserProjectsService_DeleteUserArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/DeleteUserArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.DeleteUserArtifactRequest,
  proto.landscope.mapviewer.v1.DeleteUserArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.DeleteUserArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.DeleteUserArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.deleteUserArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteUserArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.DeleteUserArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.deleteUserArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/DeleteUserArtifact',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_DeleteUserArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest,
 *   !proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse>}
 */
const methodDescriptor_UserProjectsService_ReorderUserArtifacts = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.UserProjectsService/ReorderUserArtifacts',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest,
  proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.UserProjectsServiceClient.prototype.reorderUserArtifacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ReorderUserArtifacts',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ReorderUserArtifacts,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.UserProjectsServicePromiseClient.prototype.reorderUserArtifacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.UserProjectsService/ReorderUserArtifacts',
      request,
      metadata || {},
      methodDescriptor_UserProjectsService_ReorderUserArtifacts);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.BillingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetPlanCatalogRequest,
 *   !proto.landscope.mapviewer.v1.GetPlanCatalogResponse>}
 */
const methodDescriptor_BillingService_GetPlanCatalog = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/GetPlanCatalog',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetPlanCatalogRequest,
  proto.landscope.mapviewer.v1.GetPlanCatalogResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetPlanCatalogResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetPlanCatalogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetPlanCatalogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.getPlanCatalog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/GetPlanCatalog',
      request,
      metadata || {},
      methodDescriptor_BillingService_GetPlanCatalog,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetPlanCatalogResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.getPlanCatalog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/GetPlanCatalog',
      request,
      metadata || {},
      methodDescriptor_BillingService_GetPlanCatalog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetMyEntitlementsRequest,
 *   !proto.landscope.mapviewer.v1.GetMyEntitlementsResponse>}
 */
const methodDescriptor_BillingService_GetMyEntitlements = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/GetMyEntitlements',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetMyEntitlementsRequest,
  proto.landscope.mapviewer.v1.GetMyEntitlementsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetMyEntitlementsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.getMyEntitlements =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/GetMyEntitlements',
      request,
      metadata || {},
      methodDescriptor_BillingService_GetMyEntitlements,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.getMyEntitlements =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/GetMyEntitlements',
      request,
      metadata || {},
      methodDescriptor_BillingService_GetMyEntitlements);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest,
 *   !proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse>}
 */
const methodDescriptor_BillingService_InitiateCheckout = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/InitiateCheckout',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest,
  proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.initiateCheckout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/InitiateCheckout',
      request,
      metadata || {},
      methodDescriptor_BillingService_InitiateCheckout,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.initiateCheckout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/InitiateCheckout',
      request,
      metadata || {},
      methodDescriptor_BillingService_InitiateCheckout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetCheckoutStatusRequest,
 *   !proto.landscope.mapviewer.v1.GetCheckoutStatusResponse>}
 */
const methodDescriptor_BillingService_GetCheckoutStatus = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/GetCheckoutStatus',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetCheckoutStatusRequest,
  proto.landscope.mapviewer.v1.GetCheckoutStatusResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetCheckoutStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.getCheckoutStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/GetCheckoutStatus',
      request,
      metadata || {},
      methodDescriptor_BillingService_GetCheckoutStatus,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.getCheckoutStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/GetCheckoutStatus',
      request,
      metadata || {},
      methodDescriptor_BillingService_GetCheckoutStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.SetCustomerIntentRequest,
 *   !proto.landscope.mapviewer.v1.SetCustomerIntentResponse>}
 */
const methodDescriptor_BillingService_SetCustomerIntent = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/SetCustomerIntent',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.SetCustomerIntentRequest,
  proto.landscope.mapviewer.v1.SetCustomerIntentResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.SetCustomerIntentResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.SetCustomerIntentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.SetCustomerIntentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.setCustomerIntent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/SetCustomerIntent',
      request,
      metadata || {},
      methodDescriptor_BillingService_SetCustomerIntent,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.SetCustomerIntentResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.setCustomerIntent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/SetCustomerIntent',
      request,
      metadata || {},
      methodDescriptor_BillingService_SetCustomerIntent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ValidateCouponRequest,
 *   !proto.landscope.mapviewer.v1.ValidateCouponResponse>}
 */
const methodDescriptor_BillingService_ValidateCoupon = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/ValidateCoupon',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ValidateCouponRequest,
  proto.landscope.mapviewer.v1.ValidateCouponResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ValidateCouponRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ValidateCouponResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ValidateCouponRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ValidateCouponResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ValidateCouponResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.validateCoupon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/ValidateCoupon',
      request,
      metadata || {},
      methodDescriptor_BillingService_ValidateCoupon,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ValidateCouponRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ValidateCouponResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.validateCoupon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/ValidateCoupon',
      request,
      metadata || {},
      methodDescriptor_BillingService_ValidateCoupon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest,
 *   !proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse>}
 */
const methodDescriptor_BillingService_CreateBillingPortalSession = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/CreateBillingPortalSession',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest,
  proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.createBillingPortalSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/CreateBillingPortalSession',
      request,
      metadata || {},
      methodDescriptor_BillingService_CreateBillingPortalSession,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.createBillingPortalSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/CreateBillingPortalSession',
      request,
      metadata || {},
      methodDescriptor_BillingService_CreateBillingPortalSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetSeatReviewStateRequest,
 *   !proto.landscope.mapviewer.v1.GetSeatReviewStateResponse>}
 */
const methodDescriptor_BillingService_GetSeatReviewState = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/GetSeatReviewState',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetSeatReviewStateRequest,
  proto.landscope.mapviewer.v1.GetSeatReviewStateResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetSeatReviewStateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.getSeatReviewState =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/GetSeatReviewState',
      request,
      metadata || {},
      methodDescriptor_BillingService_GetSeatReviewState,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.getSeatReviewState =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/GetSeatReviewState',
      request,
      metadata || {},
      methodDescriptor_BillingService_GetSeatReviewState);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest,
 *   !proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse>}
 */
const methodDescriptor_BillingService_ConfirmProjectSeatRebase = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/ConfirmProjectSeatRebase',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest,
  proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.confirmProjectSeatRebase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/ConfirmProjectSeatRebase',
      request,
      metadata || {},
      methodDescriptor_BillingService_ConfirmProjectSeatRebase,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.confirmProjectSeatRebase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/ConfirmProjectSeatRebase',
      request,
      metadata || {},
      methodDescriptor_BillingService_ConfirmProjectSeatRebase);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.QuotePlanRequest,
 *   !proto.landscope.mapviewer.v1.QuotePlanResponse>}
 */
const methodDescriptor_BillingService_QuotePlan = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.BillingService/QuotePlan',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.QuotePlanRequest,
  proto.landscope.mapviewer.v1.QuotePlanResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.QuotePlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.QuotePlanResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.QuotePlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.QuotePlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.QuotePlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.BillingServiceClient.prototype.quotePlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/QuotePlan',
      request,
      metadata || {},
      methodDescriptor_BillingService_QuotePlan,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.QuotePlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.QuotePlanResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.BillingServicePromiseClient.prototype.quotePlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.BillingService/QuotePlan',
      request,
      metadata || {},
      methodDescriptor_BillingService_QuotePlan);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.LidarCoverageServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.LidarCoverageServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest,
 *   !proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse>}
 */
const methodDescriptor_LidarCoverageService_CheckCoverageAvailability = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.LidarCoverageService/CheckCoverageAvailability',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest,
  proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.LidarCoverageServiceClient.prototype.checkCoverageAvailability =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.LidarCoverageService/CheckCoverageAvailability',
      request,
      metadata || {},
      methodDescriptor_LidarCoverageService_CheckCoverageAvailability,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.LidarCoverageServicePromiseClient.prototype.checkCoverageAvailability =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.LidarCoverageService/CheckCoverageAvailability',
      request,
      metadata || {},
      methodDescriptor_LidarCoverageService_CheckCoverageAvailability);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.landscope.mapviewer.v1.GetUserProjectsResponse>}
 */
const methodDescriptor_DemoProjectsService_GetDemoProjects = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.DemoProjectsService/GetDemoProjects',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.landscope.mapviewer.v1.GetUserProjectsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetUserProjectsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetUserProjectsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetUserProjectsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient.prototype.getDemoProjects =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetDemoProjects',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetDemoProjects,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetUserProjectsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient.prototype.getDemoProjects =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetDemoProjects',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetDemoProjects);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetProjectStructureRequest,
 *   !proto.landscope.mapviewer.v1.GetProjectStructureResponse>}
 */
const methodDescriptor_DemoProjectsService_GetProjectStructure = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.DemoProjectsService/GetProjectStructure',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetProjectStructureRequest,
  proto.landscope.mapviewer.v1.GetProjectStructureResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetProjectStructureResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetProjectStructureResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetProjectStructureResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient.prototype.getProjectStructure =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetProjectStructure',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetProjectStructure,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetProjectStructureResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient.prototype.getProjectStructure =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetProjectStructure',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetProjectStructure);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetArtifactRequest,
 *   !proto.landscope.mapviewer.v1.GetArtifactResponse>}
 */
const methodDescriptor_DemoProjectsService_GetArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.DemoProjectsService/GetArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetArtifactRequest,
  proto.landscope.mapviewer.v1.GetArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient.prototype.getArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetArtifact',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient.prototype.getArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetArtifact',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetProjectStatisticsRequest,
 *   !proto.landscope.mapviewer.v1.GetProjectStatisticsResponse>}
 */
const methodDescriptor_DemoProjectsService_GetProjectStatistics = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.DemoProjectsService/GetProjectStatistics',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetProjectStatisticsRequest,
  proto.landscope.mapviewer.v1.GetProjectStatisticsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetProjectStatisticsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient.prototype.getProjectStatistics =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetProjectStatistics',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetProjectStatistics,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient.prototype.getProjectStatistics =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetProjectStatistics',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetProjectStatistics);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CreateProjectDownloadRequest,
 *   !proto.landscope.mapviewer.v1.CreateProjectDownloadResponse>}
 */
const methodDescriptor_DemoProjectsService_CreateProjectDownload = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.DemoProjectsService/CreateProjectDownload',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CreateProjectDownloadRequest,
  proto.landscope.mapviewer.v1.CreateProjectDownloadResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CreateProjectDownloadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient.prototype.createProjectDownload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/CreateProjectDownload',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_CreateProjectDownload,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient.prototype.createProjectDownload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/CreateProjectDownload',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_CreateProjectDownload);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest,
 *   !proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse>}
 */
const methodDescriptor_DemoProjectsService_GetProjectDownloadStatus = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.DemoProjectsService/GetProjectDownloadStatus',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest,
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient.prototype.getProjectDownloadStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetProjectDownloadStatus',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetProjectDownloadStatus,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient.prototype.getProjectDownloadStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetProjectDownloadStatus',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetProjectDownloadStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.ExportArtifactRequest,
 *   !proto.landscope.mapviewer.v1.ExportArtifactResponse>}
 */
const methodDescriptor_DemoProjectsService_ExportArtifact = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.DemoProjectsService/ExportArtifact',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.ExportArtifactRequest,
  proto.landscope.mapviewer.v1.ExportArtifactResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.ExportArtifactResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.ExportArtifactResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.ExportArtifactResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient.prototype.exportArtifact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/ExportArtifact',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_ExportArtifact,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.ExportArtifactResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient.prototype.exportArtifact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/ExportArtifact',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_ExportArtifact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest,
 *   !proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse>}
 */
const methodDescriptor_DemoProjectsService_GetSupportedExportFormats = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.DemoProjectsService/GetSupportedExportFormats',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest,
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.DemoProjectsServiceClient.prototype.getSupportedExportFormats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetSupportedExportFormats',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetSupportedExportFormats,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.DemoProjectsServicePromiseClient.prototype.getSupportedExportFormats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.DemoProjectsService/GetSupportedExportFormats',
      request,
      metadata || {},
      methodDescriptor_DemoProjectsService_GetSupportedExportFormats);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.ElevationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.landscope.mapviewer.v1.ElevationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.SampleElevationRequest,
 *   !proto.landscope.mapviewer.v1.SampleElevationResponse>}
 */
const methodDescriptor_ElevationService_SampleElevation = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.ElevationService/SampleElevation',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.SampleElevationRequest,
  proto.landscope.mapviewer.v1.SampleElevationResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.SampleElevationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.SampleElevationResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.SampleElevationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.SampleElevationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.SampleElevationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.ElevationServiceClient.prototype.sampleElevation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.ElevationService/SampleElevation',
      request,
      metadata || {},
      methodDescriptor_ElevationService_SampleElevation,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.SampleElevationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.SampleElevationResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.ElevationServicePromiseClient.prototype.sampleElevation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.ElevationService/SampleElevation',
      request,
      metadata || {},
      methodDescriptor_ElevationService_SampleElevation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetLineElevationProfileRequest,
 *   !proto.landscope.mapviewer.v1.GetLineElevationProfileResponse>}
 */
const methodDescriptor_ElevationService_GetLineElevationProfile = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.ElevationService/GetLineElevationProfile',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetLineElevationProfileRequest,
  proto.landscope.mapviewer.v1.GetLineElevationProfileResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetLineElevationProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.ElevationServiceClient.prototype.getLineElevationProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.ElevationService/GetLineElevationProfile',
      request,
      metadata || {},
      methodDescriptor_ElevationService_GetLineElevationProfile,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.ElevationServicePromiseClient.prototype.getLineElevationProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.ElevationService/GetLineElevationProfile',
      request,
      metadata || {},
      methodDescriptor_ElevationService_GetLineElevationProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest,
 *   !proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse>}
 */
const methodDescriptor_ElevationService_GetPolylineElevationProfile = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.ElevationService/GetPolylineElevationProfile',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest,
  proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.ElevationServiceClient.prototype.getPolylineElevationProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.ElevationService/GetPolylineElevationProfile',
      request,
      metadata || {},
      methodDescriptor_ElevationService_GetPolylineElevationProfile,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.ElevationServicePromiseClient.prototype.getPolylineElevationProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.ElevationService/GetPolylineElevationProfile',
      request,
      metadata || {},
      methodDescriptor_ElevationService_GetPolylineElevationProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.landscope.mapviewer.v1.CalculateStreamBufferRequest,
 *   !proto.landscope.mapviewer.v1.CalculateStreamBufferResponse>}
 */
const methodDescriptor_ElevationService_CalculateStreamBuffer = new grpc.web.MethodDescriptor(
  '/landscope.mapviewer.v1.ElevationService/CalculateStreamBuffer',
  grpc.web.MethodType.UNARY,
  proto.landscope.mapviewer.v1.CalculateStreamBufferRequest,
  proto.landscope.mapviewer.v1.CalculateStreamBufferResponse,
  /**
   * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.deserializeBinary
);


/**
 * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.landscope.mapviewer.v1.CalculateStreamBufferResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.landscope.mapviewer.v1.ElevationServiceClient.prototype.calculateStreamBuffer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/landscope.mapviewer.v1.ElevationService/CalculateStreamBuffer',
      request,
      metadata || {},
      methodDescriptor_ElevationService_CalculateStreamBuffer,
      callback);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse>}
 *     Promise that resolves to the response
 */
proto.landscope.mapviewer.v1.ElevationServicePromiseClient.prototype.calculateStreamBuffer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/landscope.mapviewer.v1.ElevationService/CalculateStreamBuffer',
      request,
      metadata || {},
      methodDescriptor_ElevationService_CalculateStreamBuffer);
};


module.exports = proto.landscope.mapviewer.v1;

